export default [
  {
    'text': '콜 수신 대기',
    'state': 'READY'
  },
  {
    'text': '운행 안함',
    'state': 'STOP'
  },
  {
    'text': '승객 태우러 가는 중',
    'state': 'MATCHED'
  },
  {
    'text': '첫 승객 탑승',
    'state': 'FIRST_BOARDED'
  },
  {
    'text': '두번째 승객 탑승',
    'state': 'SECOND_BOARDED'
  },
  {
    'text': '첫번째 목적지 도착',
    'state': 'FIRST_DEST'
  },
  {
    'text': '두번째 목적지 도착',
    'state': 'SECOND_DEST'
  },
  {
    'text': '콜 수신 취소',
    'state': 'CANCELED'
  },
];



// WEBPACK FOOTER //
// ./src/api/runningState.js